import React from 'react';

class Visualization extends React.Component {
  constructor() {
    super();
    this.container = null;
  }

  componentDidMount() {
    this.props.viz.create(this.container, this.getChartState());
  }

  componentDidUpdate() {
    this.props.viz.update(this.container, this.getChartState());
  }

  componentWillUnmount() {
    this.props.viz.destroy(this.props.id);
  }

  getChartState() {
    return {
      ...this.props,
      width: this.container.offsetWidth,
      height: this.container.offsetHeight,
      id: this.props.id,
    };
  }

  render() {
    return (
      <div
        className={this.props.className || 'Visualization'}
        id={`visualizationDiv${this.props.id}`}
        ref={node => {
          this.container = node;
        }}
        style={{ width: '100%', height: this.props.height }}
      />
    );
  }
}

export default Visualization;
